import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Switch } from '@/components/ui/switch';
import { Button } from '@/components/ui/button';

const API = process.env.REACT_APP_BACKEND_URL;

const LABELS = {
  low_stock: { title: 'Stock bas', desc: 'Alerte quand un article passe sous le seuil critique' },
  contract_expiry: { title: 'Contrats expirants', desc: 'Alerte 30 jours avant l\'échéance d\'un contrat' },
  incidents: { title: 'Incidents & rapports', desc: 'Nouveaux rapports d\'inspectorat marqués urgents' },
};

const NotificationPrefsDialog = ({ open, onOpenChange }) => {
  const [prefs, setPrefs] = useState({ low_stock: true, contract_expiry: true, incidents: true });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    (async () => {
      try {
        const r = await fetch(`${API}/api/users/me/notification-prefs`, { credentials: 'include' });
        if (r.ok) setPrefs(await r.json());
      } catch { /* silent */ }
    })();
  }, [open]);

  const save = async () => {
    setSaving(true);
    try {
      const r = await fetch(`${API}/api/users/me/notification-prefs`, {
        method: 'PUT', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(prefs),
      });
      if (r.ok) { toast.success('Préférences enregistrées'); onOpenChange(false); }
      else toast.error('Erreur d\'enregistrement');
    } catch { toast.error('Erreur réseau'); }
    setSaving(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0F172A] border-[#1E293B] text-[#F8FAFC] max-w-md">
        <DialogHeader>
          <DialogTitle>Préférences de notifications</DialogTitle>
          <DialogDescription className="text-[#94A3B8]">Choisissez les alertes que vous souhaitez recevoir par email, push et in-app.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-2">
          {Object.keys(LABELS).map((k) => (
            <div key={k} className="flex items-start justify-between gap-4 p-3 rounded-md bg-[#1E293B]/50 border border-[#1E293B]" data-testid={`pref-row-${k}`}>
              <div className="min-w-0">
                <p className="text-sm font-medium text-[#F8FAFC]">{LABELS[k].title}</p>
                <p className="text-xs text-[#94A3B8]">{LABELS[k].desc}</p>
              </div>
              <Switch
                checked={!!prefs[k]}
                onCheckedChange={(v) => setPrefs((p) => ({ ...p, [k]: v }))}
                data-testid={`pref-switch-${k}`}
              />
            </div>
          ))}
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-[#334155] text-[#F8FAFC] hover:bg-[#1E293B]">Annuler</Button>
          <Button onClick={save} disabled={saving} className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white" data-testid="save-prefs-btn">{saving ? 'Enregistrement...' : 'Enregistrer'}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NotificationPrefsDialog;
